function toggleHeaderClass() {
	const $win = $(window);
	const $body = $("body");
	const StaticHeaderCssClass = "header_static";
	let scrollTop;
	let topBannerHeight;

	function toggleClass() {
		scrollTop = $win.scrollTop();
		topBannerHeight = $("#topBanner").height();

		if (scrollTop > topBannerHeight) {
			$body.removeClass(StaticHeaderCssClass);
		} else {
			$body.addClass(StaticHeaderCssClass);
		}
	}

	toggleClass();
	$win.scroll(function () {
		toggleClass();
	});
}

function navGlobal() {
	const pathName = global.location.pathname.toLowerCase();
	function currentCate() {
		// cates 以網址字串判，優先條件在前，例如 sports women 不包含 women，women 不包含 men
		const cates = ["PREORDER", "Article", "SPORTS", "WOMEN", "KIDS", "MEN"];

		const pathSearch = global.location.search.toLowerCase();
		var pathSearchCate = "";
		if (pathSearch) pathSearchCate = pathSearch.split("menu=")[1] || "";

		// 依序比對 cates
		let cateName;
		for (let i = 0; i < cates.length; i++) {
			cateName = cates[i].toLowerCase();
			if (pathName.indexOf(cateName) > -1 || pathSearchCate.indexOf(cateName) > -1) {
				set(cateName);
				// 已符合條件就跳離for loop，避免重複條件
				break;
			}
		}

		// set
		function set(cateKey) {
			for (let i = 0; i < cates.length; i++) {
				if (cateKey === cates[i].toLowerCase()) {
					$(".nav li#" + cates[i]).addClass("active");
					// 已符合條件就跳離for loop，減少運算
					break;
				}
			}
		}
	}

	if (pathName.indexOf("market") == -1 && pathName.indexOf("productpage") == -1) currentCate();
}

function navDesktop() {
	// 登入按鈕顯示
	function tabStatus() {
		if (nowEnv.NowIsLogin) {
			$("li.secnav-right__signin").remove();
		} else {
			$("li.secnav-right__signout, li.secnav-right__account").remove();
		}
	}

	// tabStatus()
	$("#page-shop .product-menu").stick_in_parent(); // 貼頂套件
}

function subnavDesktop() {
	var $el = $(".subnav");

	function hover(target) {
		var isDrag = 0;
		var isEnter = 0;
		var timerOut = 0;

		$el.parent().hover(
			function () {
				var $that = $(this);

				if (!$that.find(".subnav").hasClass("subnav--newsletter")) {
					isEnter = 1;

					if (isDrag === 0) {
						$that.siblings().find(".subnav").removeClass("open");
					}
					clearTimeout(timerOut);
					$that.find(".subnav").addClass("open");
				}
			},
			function () {
				var $that = $(this);

				if (!$that.find(".subnav").hasClass("subnav--newsletter")) {
					isEnter = 0;

					timerOut = setTimeout(function () {
						if (isDrag === 0) {
							$that.find(".subnav").removeClass("open");
						}
					}, 600);
				}
			}
		);

		if (document.addEventListener) {
			document.addEventListener(
				"mousedown",
				function (e) {
					if (e.target.className === "slider") {
						isDrag = 1;
						$(this).addClass("dragging");
						$(document).one("mouseup", function () {
							if (isEnter === 0) {
								timerOut = setTimeout(function () {
									$el.removeClass("open");
								}, 1000);
							}
							isDrag = 0;
						});
					}
				},
				true
			);
		}
	}

	function click() {
		$el
			.parent()
			.find("a")
			.on("click", function () {
				var $that = $(this);

				if ($that.parent().find(".subnav").hasClass("subnav--newsletter")) {
					$that.parent().siblings().find(".subnav").removeClass("open");
					$that.parent().find(".subnav").toggleClass("open");
				}
			});
	}

	function close() {
		$el.on("click", ".subnav__close", function () {
			$(this).parent().removeClass("open");
		});
	}

	hover();
	click();
	close();
}

function navMobile() {
	const $allList = $(".category_list, .member_list, .more_list");

	function resetNav() {
		// secnav 從 header 拉出來做成 tabbar
		$(".header").after($(".secnav"));
	}

	// function fixedHeader () {
	//   const $window = $(window)
	//   const css = 'js-header'
	//   const cssShow = 'js-headerShow'
	//   let p
	//   let t
	//   let listShow

	//   $window.scroll(function () {
	//     p = $(this).scrollTop()
	//     if (p >= t && listShow === 0) { // 下滑且列表都沒有顯示時
	//       if (p > 44) {
	//         $('body').addClass(css)
	//       } else {
	//         $('body').removeClass(css)
	//       }

	//       $('body').removeClass(cssShow)
	//     } else if (p > 44) { // 上滑且卷軸超過 header 高
	//       $('body').addClass(cssShow)
	//     }

	//     setTimeout(function () {
	//       listShow = $('.category_list, .member_list, .more_list').filter(':visible').length
	//       // 避免關閉列表時立刻判斷成列表沒有顯示而觸發隱藏 header 事件
	//       t = p
	//     }, 0)
	//   })
	// }

	// function navOverFlow () {
	//   const reducer = (accumulator, currentValue) => accumulator + currentValue
	//   const $headerInner = $('.header-inner')
	//   const $nav = $('.nav')
	//   const $navInner = $nav.find('ul')
	//   const $navCell = $nav.find('li')
	//   const classNotStart = 'notNavStart'
	//   const classNotEnd = 'notNavEnd'
	//   let navCellWidth = []
	//   let navWidth = $nav.width()

	//   $.each($navCell, (i, v) => { navCellWidth.push($(v).width()) })

	//   let navInnerWidth = navCellWidth.reduce(reducer)
	//   let navPositionLeft

	//   if (navInnerWidth > navWidth) {
	//     $headerInner.addClass('notNavEnd')
	//   }

	//   $(window).resize(() => {
	//     navWidth = $nav.width()
	//     navCellWidth = []
	//     $.each($navCell, (i, v) => { navCellWidth.push($(v).width()) })
	//     navInnerWidth = navCellWidth.reduce(reducer)
	//     onNavScroll()
	//   })

	//   const onNavScroll = () => {
	//     navPositionLeft = -$navInner.position().left

	//     if (navPositionLeft <= 0) {
	//       $headerInner.removeClass(classNotStart)
	//     } else {
	//       $headerInner.addClass(classNotStart)
	//     }

	//     if (navPositionLeft >= navInnerWidth - navWidth) {
	//       $headerInner.removeClass(classNotEnd)
	//     } else {
	//       $headerInner.addClass(classNotEnd)
	//     }
	//   }

	//   $nav.scroll(onNavScroll)
	// }

	let winScrollTop;

	function toggleNav() {
		const $nav = $(".nav");
		const showClass = "js-navShow";
		const $categoryList = $(".category_list");
		$nav.on("click", (e) => {
			// 先判分類的子列表是否有展開
			if ($(e.target).hasClass(showClass) && $categoryList.filter(":visible").length > 0) {
				$(".nav a[data-cateid]").removeClass("active");
				$(".wrap").removeClass("disappear");
				$categoryList.hide();
				setTimeout(function () {
					// 非同步
					$(window).scrollTop(winScrollTop);
				});
			}

			// 再判分類列表是否有展開
			if ($(e.target).is(".nav")) {
				$nav.toggleClass(showClass);
			}
		});
	}

	function topLevel() {
		// 第一層開關
		const categoryButton = ".nav a[data-cateid]";
		const memberButton = ".secnav-right__account > a";
		const moreButton = ".secnav-right__more > a";
		const $allListButton = $(categoryButton).add($(memberButton)).add($(moreButton));

		$allListButton.on("click", function (e, target) {
			e.preventDefault();

			$(".subnav_mobile").removeClass("open"); // 關閉社群列表
			$("body").addClass("js-headerShow"); // 顯示 header

			// 判斷 target
			if ($(e.currentTarget).is(categoryButton)) {
				target = ".category_list[data-cateid=" + $(this).data("cateid") + "]";
			} else if ($(e.currentTarget).is(memberButton)) {
				target = ".member_list";
			} else if ($(e.currentTarget).is(moreButton)) {
				target = ".more_list";
			}

			// 如果所有列表都還沒開就記錄卷軸位置
			if ($allList.filter(":visible").length === 0) {
				winScrollTop = $(window).scrollTop();
			}

			// 如果自己沒開表示正要執行打開動作
			if ($(target).filter(":visible").length === 0) {
				$allListButton.removeClass("active");
				$(this).addClass("active");
				$(".recommend, .event-panel").hide();
				$(".wrap").addClass("disappear"); // 避免重新 loading 造成畫面閃爍，使用css控制
				$(target).show();
				$allList.not(target).hide(); // 除了自己以外的都hide吧
				setTimeout(function () {
					// 非同步
					$(window).scrollTop(0);
				});
			} else {
				// 自己已經開了
				$(this).removeClass("active");
				$(".recommend, .event-panel").show();
				$(".wrap").removeClass("disappear");
				$(target).hide();
				setTimeout(function () {
					// 非同步
					$(window).scrollTop(winScrollTop);
				});
			}

			// more跟member可能target為span，需阻止事件冒泡
			e.stopPropagation();
		});

		/* 設計決定不加有子層的提示，所以這段先隱藏，如果要加再打開
    // 有子層時增加 className 'open'
    // $allList_li = $allList.find('li'), 子層提示樣式用，目前沒有
    for (var i = 0; i < $allList_li.length; i ++) {
      if($allList_li.eq(i).children('ul').length > 0){
        $allList_li.children('a').eq(i).addClass('open')
      }
    }
    */
	}

	// 社群由 subnavMobile() 控制

	function subLevel() {
		// 子層開關
		var $allListSubButton = $allList.find("a");
		$allListSubButton.on("click", function (e) {
			// 有子層才會跑
			if ($(this).next("ul").children("li").length > 0) {
				e.preventDefault();
				$(this).next("ul").toggle();
				/* 沒有提示樣式
        $(this).toggleClass('open close')
        */
			}
		});

		// 預設打開第二個
		$(".more_list > li:nth-child(2) > a").click();
	}

	// 登入按鈕顯示
	function tabStatus() {
		$("li.secnav-right__signout").remove();
		// if (nowEnv.NowIsLogin) {
		//   $('li.secnav-right__signin').remove()
		// } else {
		//   $('li.secnav-right__account').remove()
		// }
	}

	if ($(".header").length > 0) {
		resetNav();
		// fixedHeader()
		// navOverFlow()
		toggleNav();
		topLevel();
		subLevel();
		tabStatus();
	}
}

function subnavMobile() {
	const $el = $(".subnav_mobile");

	$el.siblings("a").on("click", function () {
		$(this).siblings(".subnav_mobile").toggleClass("open");
	});

	$el.find(".clossFollow").on("click", function () {
		$(this).parent(".subnav_mobile").toggleClass("open");
	});
}

function globalSearch(searchbox) {
	var $el = $(searchbox);
	var $form = $el.children("form");
	var $input = $form.find(":text");

	$(searchbox).on("click", function (event) {
		event.stopPropagation();
	});

	$form.find(".global-search__btn").on("click", function (event) {
		event.preventDefault();
		$form.trigger("submit");
	});

	$input.on("keydown", function (event) {
		if (event.keyCode === 13) {
			event.preventDefault();
		}
	});

	$input.on("keyup", function (event) {
		if (event.keyCode === 13) {
			$form.trigger("submit");
		}
	});

	$form.on("submit", function (event) {
		var text = $input.val();

		$input.blur();

		if (text === "") {
			nowBrand.alert("請輸入文字", "貼心提醒");
			event.preventDefault();
		}
	});
}

export default {
	toggleHeaderClass: toggleHeaderClass,
	navGlobal: navGlobal,
	navDesktop: navDesktop,
	subnavDesktop: subnavDesktop,
	navMobile: navMobile,
	subnavMobile: subnavMobile,
	globalSearch: globalSearch,
};
